"use client"

import { Toaster as Sonner } from "sonner"

const Toaster = ({
    ...props
}) => {
    return (
        <Sonner
            theme="dark"
            className="toaster group"
            toastOptions={{
                classNames: {
                    toast:
                        "group toast group-[.toaster]:bg-zinc-900 group-[.toaster]:text-zinc-100 group-[.toaster]:border-zinc-800 group-[.toaster]:shadow-lg",
                    description: "group-[.toast]:text-zinc-400",
                    actionButton:
                        "group-[.toast]:bg-emerald-500 group-[.toast]:text-zinc-950",
                    cancelButton:
                        "group-[.toast]:bg-zinc-700 group-[.toast]:text-zinc-400",
                },
            }}
            {...props}
        />
    )
}

export { Toaster }
